export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive("no-right-click", {
        mounted(el) {
            el.addEventListener("contextmenu", (e) => {
                e.preventDefault();
                return false;
            });
        },
    });
});
